export default "__VITE_ASSET__DEeUh4KF__"